
import VenueIntroText from './VenueIntroText.vue';
import VenueIntroSwiper from './VenueIntroSwiper.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Swiper,
    SwiperSlide,
    VenueIntroText,
    VenueIntroSwiper
  }
})
export default class extends Vue {
  @Prop() data!: any;

}
